import Shimmer from "./Shimmer";
import ShimmerItem from "./Shimmer/ShimmerItem";


export default function BlogShimmer() {
  return (
    <div className="p-3 w-100%">

      {/* Initial 3 paragraphs (3 lines each) */}
      {[...Array(3)].map((_, i) => (
        <Shimmer
          key={`para-top-${i}`}
          gap="8px"
          direction="column"
          className="mb-2"
        >
          <ShimmerItem height="16px" width="100%" />
          <ShimmerItem height="16px" width="90%" />
          <ShimmerItem height="16px" width="80%" />
        </Shimmer>
      ))}

      {/* Image placeholder */}
      <ShimmerItem height="280px" width="100%" className="mb-2" />

      {/* Next 3 paragraphs (3 lines each) */}
      {[...Array(3)].map((_, i) => (
        <Shimmer
          key={`para-mid-${i}`}
          gap="8px"
          direction="column"
          className="mb-2"
        >
          <ShimmerItem height="16px" width="95%" />
          <ShimmerItem height="16px" width="85%" />
          <ShimmerItem height="16px" width="70%" />
        </Shimmer>
      ))}

      {/* Table (3 columns × 7 rows) */}
      <Shimmer gap="8px" direction="column" className="mb-2">
        {[...Array(7)].map((_, rowIndex) => (
          <Shimmer key={`row-${rowIndex}`} gap="8px" direction="row">
            <ShimmerItem height="20px" width="30%" />
            <ShimmerItem height="20px" width="30%" />
            <ShimmerItem height="20px" width="30%" />
          </Shimmer>
        ))}
      </Shimmer>

      {/* Extra paragraphs (2–3 lines each) */}
      {[...Array(2)].map((_, i) => (
        <Shimmer
          key={`para-bottom-${i}`}
          gap="8px"
          direction="column"
          className="mb-2"
        >
          <ShimmerItem height="16px" width="100%" />
          <ShimmerItem height="16px" width="85%" />
          <ShimmerItem height="16px" width="60%" />
        </Shimmer>
      ))}

    </div>
  );
}
